module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-home-top"
  }, [_c('ForumThreadList', {
    ref: "topThreadList",
    staticClass: "top-thread-list",
    attrs: {
      "sortable": true,
      "sort-order": _vm.sortOrder,
      "threads": _vm.topThreads
    },
    on: {
      "update:sort-order": function($event) {
        _vm.$emit('update:sort-order', $event)
      }
    }
  }), _vm._v(" "), (!_vm.canLoadMoreTopThreads) ? _c('div', {
    staticClass: "between-threads-msg"
  }, [(_vm.topThreads.length === 0) ? _c('em', [_vm._v("\n            No top threads this " + _vm._s(_vm.period) + ".\n        ")]) : _c('em', [_vm._v("\n            End of top threads for this " + _vm._s(_vm.period) + ".\n        ")])]) : _vm._e(), _vm._v(" "), (!_vm.canLoadMoreTopThreads) ? _c('ForumThreadList', {
    ref: "otherThreadList",
    staticClass: "other-thread-list",
    attrs: {
      "header": false,
      "sort-order": _vm.sortOrder,
      "threads": _vm.otherThreads
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canLoadMoreThreads) ? _c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingThreads),
      expression: "loadingThreads"
    }]
  }) : _vm._e(), _vm._v(" "), (!_vm.canLoadMoreThreads) ? _c('div', {
    staticClass: "after-threads-msg"
  }, [_vm._v("\n        That's all, folks!\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e79d8ac2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ForumHomeTop.vue
// module id = 2143
// module chunks = 2